import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { FC } from "react";
import { IoLanguageOutline } from "react-icons/io5";
import { useAppSelector } from "slice";
import CardTitle from "../CardTitle";
import {
    Bullet,
    BulletColumn,
    CardWrapper,
    ItalicText,
    Label,
} from "../PersonalInfo/PersonalInfo.styled";

export const LocationAndLanguage: FC = () => {
    const { user_location, user_languages } = useAppSelector(
        (state) => state.user
    );

    return (
        <CardWrapper>
            <CardTitle
                title="Location and Language"
                icon={<IoLanguageOutline />}
                editRoute={
                    routeConstants.profile.editProfile.root +
                    routeConstants.profile.editProfile.locationAndLanguages
                }
            />
            <Grid row={true} marginTop={1} columnGap={1}>
                {user_location?.country && (
                    <BulletColumn>
                        <Label variant="body2">Country</Label>
                        <Bullet>
                            <Text variant="body2">
                                {user_location?.country}
                            </Text>
                        </Bullet>
                    </BulletColumn>
                )}
                {user_location?.city && (
                    <BulletColumn>
                        <Label variant="body2">City</Label>
                        <Bullet>
                            <Text variant="body2">{user_location?.city}</Text>
                        </Bullet>
                    </BulletColumn>
                )}
                {user_languages && user_languages.length > 0 && (
                    <BulletColumn>
                        <Label variant="body2">Language</Label>
                        <Grid row={true} columnGap={1}>
                            {user_languages.map((language) => (
                                <Bullet key={language.id}>
                                    <Text variant="body2">
                                        {language.language}{" "}
                                        <ItalicText variant="body2">
                                            ({language.level})
                                        </ItalicText>
                                    </Text>
                                </Bullet>
                            ))}
                        </Grid>
                    </BulletColumn>
                )}
            </Grid>
        </CardWrapper>
    );
};
